import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

export default function PrivacyPage() {
  const SITE_URL = __VITE_SITE_URL__;

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-24 pb-16">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-2">Privacy Policy</h1>
          <p className="text-foreground-400 text-sm mb-10">Ultimo aggiornamento: Luglio 2026</p>
          <div className="prose prose-sm text-foreground-600 space-y-6">
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-800 mb-3">1. Introduzione</h2>
              <p>La presente Privacy Policy descrive come itaobuyspread.lol raccoglie, utilizza e protegge le informazioni degli utenti che visitano il nostro sito. La tua privacy è importante per noi e ci impegniamo a proteggere i tuoi dati personali.</p>
            </section>
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-800 mb-3">2. Dati Raccolti</h2>
              <p>Il nostro sito non raccoglie attivamente dati personali degli utenti. Potremmo utilizzare cookie tecnici per migliorare l&apos;esperienza di navigazione. I link esterni reindirizzano a siti di terze parti, le cui politiche sulla privacy sono indipendenti dalla nostra.</p>
            </section>
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-800 mb-3">3. Cookie</h2>
              <p>Utilizziamo esclusivamente cookie tecnici essenziali per il funzionamento del sito. Non utilizziamo cookie di tracciamento o profilazione. Puoi gestire le preferenze sui cookie attraverso le impostazioni del tuo browser.</p>
            </section>
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-800 mb-3">4. Contatti</h2>
              <p>Per qualsiasi domanda sulla presente Privacy Policy, puoi contattarci attraverso i canali indicati sul nostro sito principale.</p>
            </section>
          </div>
          <Link to="/" className="inline-flex items-center gap-2 mt-10 text-sm text-primary-500 hover:text-primary-600 transition-colors">
            <i className="ri-arrow-left-line"></i> Torna alla Home
          </Link>
        </div>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'Privacy Policy — Itaobuy Spreadsheet Italia',
            description: 'Privacy Policy di itaobuyspread.lol. Informazioni su come raccogliamo, utilizziamo e proteggiamo i dati personali degli utenti.',
            inLanguage: 'it',
            isPartOf: {
              '@type': 'WebSite',
              name: 'Itaobuy Spreadsheet Italia',
              url: SITE_URL,
            },
          }),
        }}
      />
    </div>
  );
}